"use strict";

PF.Field.RadioGroup = class RadioGroup extends PF.Field
	{
	static get options()
		{
		return {
			listConfig: {
				html: {
					wrapper: PF.Field.RadioGroup.templates.listWrapper,
				},
				models: undefined,
				modelsConfig: {
					loadOnInit: false
				},
				itemClass: PF.Field.RadioGroup.Item,
				title: 'Название',
			},
			model: new PF.Model({}),
			key: 'value',
			idKey: undefined, //foreign id key in model, like 'city_id'
			dictIdKey: 'id',

			showInfo: true,
			helper: '',
			simpleName: '@{model.name}',
			nullItem: PF.Field.RadioGroup.NullItem,
			errors: {},
			allowNull: false,

			audioLabels: ''
		};
		}


	static get templates()
		{
		return {
			//language=HTML
			listWrapper: `
				${PF.List.templates.wrapper}
				<div class="info" pf="info">&nbsp</div>
			`,
		};
		}


	init()
		{
		this.selected = undefined;

		if (this.dict !== undefined)
			{
			if (this.dict.startsWith('model'))
				{
				this.listConfig.models = this.model.get(this.dict.replace(/^model\./, ''));
				}
			else
				{
				this.listConfig.modelsConfig.raw = this.model.options.dicts[this.dict].toJSON();
				}
			}

		this.list = new PF.List({
			dom: this.dom,
			...this.listConfig,
			group: this
		});
		this.dom.element.classes.radioGroup = true;

		// this.list.models.order = `(IF ${this.list.models.idIndex} = ${this.model.get(this.key, null, null, (v) => "'" + v.get(this.list.models.idIndex) + "'")} THEN 0 ELSE 1 END IF)`;

		if (this.model.get(this.key, null, null, (v) => v.get(this.list.models.idIndex)) !== undefined)
			{
			this.list.models.order = `(case when ${this.list.models.idIndex} = ${this.model.get(this.key, null, null, (v) => "'" + v.get(this.list.models.idIndex) + "'")} THEN 0 ELSE 1 END )`;
			}
		this.name = 'radio-' + PF.H.randomString();

		this.nullItem = this.list.create(new PF.Model({raw: null}));
		this.list.unshift(this.nullItem);
		this.list.on('add', () => {
			this.list.dom.ul.prepend(this.nullItem.dom.item);
		});


		this.bindDom({wrapper: 'class:error'}, 'error', (e) => e !== '');
		this.bindDom({info: 'html'}, ['helper', 'error'], (h, e) => e !== '' ? e : h !== '' ? h : '&nbsp;');
		this.bindDom({info: 'show'}, 'showInfo');


		if (this.model.get(this.key, null, null) === null)
			{
			this.model.setData(this.key, this.nullItem.model, true);
			}

		this.list.models.on(['changed', 'load-part'], () => {
			let item = this.findItemByModel(this.model.get(this.key));
			if (item !== this.nullItem)
				{
				this.selected = this.findItemByModel(this.model.get(this.key));
				this.validate(true);
				}
		}, true);

		this.model.onChange(this.key, () => {
			let item = this.findItemByModel(this.model.get(this.key));
			if (item !== this.nullItem)
				{
				this.selected = this.findItemByModel(this.model.get(this.key));
				this.validate(true);
				}
		}, true);

		this.onChange('selected', () => {
			// console.log(`${this.name}: change selected value`, this.selected);
			this.model.setData(this.key, this.selected.model);
			this.selected.dom.input.value = true;
			if (this.idKey !== undefined)
				{
				this.model.setData(this.idKey, this.selected.model.get(this.dictIdKey));
				}
		});


		// this.list.models.on(['changed', 'partLoaded'], () => {
		//     // console.log(`${this.name}: dict changed`, this.model.get(this.key));
		//     this.selected = this.findItemByModel(this.model.get(this.key));
		//     this.validate(true);
		// });

		// this.onChange('selected', () => {
		//     // console.log(`${this.name}: change selected value`, this.selected);
		//     this.model.setData(this.key, this.selected.model);
		//     this.selected.dom.input.value = true;
		//     if (this.idKey !== undefined) {
		//         this.model.setData(this.idKey, this.selected.model.get(this.dictIdKey));
		//     }
		// });
		this.on('selected.destroy', () => this.selected = this.nullItem);

		this.list.models.loadPart();
		}


	findItemByModel(model)
		{
		for (let i = 0; i < this.list.length; i++)
			{
			if (PF.H.compareByPks(model, this.list[i].model))
				{
				return this.list[i];
				}
			}
		return this.nullItem;
		}


	validate(silent, error)
		{
		if (this.required)
			{
			if (this.selected === null || this.selected.model === null || this.selected.model.isNull() === true)
				{
				return super.validate(silent, this.errors.required);
				}
			}

		return super.validate(silent, error);
		}
	};


PF.Field.RadioGroup.Item = class Item extends PF.List.Item
	{
	static get options()
		{
		return {};
		}

	get renderer()
		{
		//language=HTML
		return `
			<li pf="item">
				<label class="item-radio item-content" pf="label">
					<input type="radio" pf="input">
					<i class="icon icon-radio"></i>
				
					${this.model.isNull() !== true ? this.itemInner : this.nullItemInner}
				</label>
			</li>
		`;
		}

	get itemInner()
		{
		//language=HTML
		return `
			<div class="item-inner">
				<div class="item-title">
					${this.list.group.simpleName}
				</div>
			</div>`;
		}

	get audioName()
		{
		return PF.H.applyContext(this.list.group.simpleName, this);
		}

	get nullItemInner()
		{
		//language=HTML
		return `
		  <div class="item-inner" pf="itemInner">
			  <div class="item-title">
				  Нет данных
			  </div>
		  </div>`;
		}

	onRender(event)
		{
		super.onRender(event);
		this.dom.input.bindAll();
		this.dom.input.attributes.name = this.list.group.name;

		this.bindDom({item: 'hide'}, ['list.group.allowNull', 'model.options.isNull'], (allow, is) => {
			return is === true && allow === false;
		});

		this.dom.input.onValue('value', true, () => {
			if (this.list.group.selected !== this && this.list.group.selected !== undefined)
				{
				this.list.group.selected.dom.input.value = false;
				}
			this.list.group.selected = this;
		});

		// this.onValue('list.group.selected', this, () => {
		// 	this.dom.input.value = true;
		// });
		this.onChange('list.group.selected', () => {
			this.dom.input.value = this.list.group.selected === this;
		})

		this.dom.itemInner = new PF.Dom.Node(this.model.isNull() === true ? '<span>&nbsp;</span>' : this.itemInner);

		// this.dom.load(this.model.isNull() === true ? '' : this.itemInner, 'itemInner');
		this.dom.itemInner.bindObject(this);
		}
	};